import {O} from "web-vcore";
import {JourneyState} from "./tools/journey.js";
import {MonitorState} from "./tools/monitor";
import {PestState} from "./tools/pest.js";
import {TrainingState} from "./tools/training";
import {ignore} from "mobx-sync";
import {JournalEntry, JournalSegment} from "../../Server/DB/journalEntries/@JournalEntry.js";
import {VRState} from "./tools/vr.js";
import {EchoHuntState} from "./tools/echoHunt.js";

export class ToolsState {
	@O accessor subpage = "monitor";
	@O accessor monitor = new MonitorState();
	@O accessor training = new TrainingState();
	@O accessor pest = new PestState();
	@O accessor vr = new VRState();
	@O accessor echoHunt = new EchoHuntState();
}